<template>
  <v-container class="workspaces">
    <v-row>
      <v-col cols="10" align="left">
        <span class="header">Select a workspace.</span>
      </v-col>
      <v-col cols="2" align="left">
        <v-btn
          style="min-width: 0"
          @click="logout"
          :disabled="loggingOut"
          :loading="loggingOut"
        >
          <span class="truncate">LOGOUT</span></v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-alert border="top" outlined type="error" v-if="workSpaceError">
          Oops! We did not find any workspaces associated with your account.
        </v-alert>
        <v-alert
          border="top"
          outlined
          type="error"
          v-if="inactiveWorkspaceSelected"
        >
          The selected workspace's subscription has expired. Please contact
          Valenz Support at assurancesupport@valenzhealth.com for
          assistance.</v-alert
        >
        <v-virtual-scroll
          :items="workspaces"
          height="180"
          item-height="60"
          position="center"
        >
          <template v-slot:default="{ item }">
            <v-list-item
              :key="item.id"
              width="100%"
              outlined
              v-on="on"
              @click="navigateToWorkspace(item)"
            >
              <v-list-item-content>
                <v-list-item-title align="left" class="workSpaceItem">
                  {{ item.displayName }}
                </v-list-item-title>
              </v-list-item-content>
              <v-icon medium color="error" v-show="!item.isActive"
                >mdi-alert-octagon-outline</v-icon
              >
              <v-list-item-action>
                <v-icon medium :id="item.id">mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//For best presentation of displayed workspaces
//Keep the v-virtual-scoll "height" a multiple of its "item-height" :)
export default {
  name: "WorkSpaceListing",
  data() {
    return {
      loggingOut: false,
      inactiveWorkspaceSelected: false,
    };
  },
  computed: {
    workspaces() {
      return this.$store.getters["workspaces/getWorkSpaces"];
    },
    workSpaceError() {
      return this.$store.getters["workspaces/getWorkSpaces"].length == 0;
    },
    isLoading() {
      return this.$store.getters.getIsLoading;
    },
  },
  methods: {
    navigateToWorkspace(workspace) {
      if (workspace.isActive) {
        let workspaceId = workspace.id;
        let workspaceIDKey =
          this.$store.getters["workspaces/getWorkspaceIDKey"];

        let searchParams = {};
        if (workspaceIDKey) {
          searchParams[workspaceIDKey] = workspaceId;
        }

        let queryParams = new URLSearchParams(searchParams);
        window.location.href =
          this.$store.getters["workspaces/getWorkSpaceURL"] +
          "?" +
          queryParams.toString();
      } else {
        this.inactiveWorkspaceSelected = true;
        setTimeout(() => {
          this.inactiveWorkspaceSelected = false;
        }, 5000);
      }
    },
    logout() {
      this.loggingOut = true;
      this.$store.dispatch("login/logoutUserAsync").then(() => {
        this.$store.dispatch("workspaces/reset").then(() => {
          this.loggingOut = false;
          this.$router.push("/login");
        });
      });
    },
  },
  mounted() {
    //GET workspaces to load user workspaces for listing
    this.$store
      .dispatch("setLoading", true)
      .then(() => this.$store.dispatch("workspaces/getWorkSpacesAsync"))
      .then(() => this.$store.dispatch("setLoading", false));
  },
};
</script>

<style scoped>
.header {
  font-size: 32px;
}

.displayName {
  font-size: 32px;
}

.workSpaceItem {
  font-size: 32px;
}

.workSpaces {
  width: 50%;
}

.truncate {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
